/**
 * Catalogue boutique.
 * Un seul article pour l’instant (stickers) — structure prête pour d’autres produits.
 * Libellés via i18n : shopProducts.{id}.name|short|description
 *
 * Images réelles : renseigner `images` (chemins public/).
 * Voir public/pictures/shop/README.md
 * Sans images, fallback SVG (motifs) via StickerArt.
 */

export const SHIPPING_OPTIONS = [
  { id: 'standard', price: 0 },
]

export const FREE_SHIPPING_THRESHOLD = 0

/** Paiement : Stripe (carte bancaire). Affiché pour transparence client. */
export const PAYMENT_PROVIDER = 'stripe'

/** Catégories disponibles (filtre boutique). */
export const PRODUCT_CATEGORIES = ['stickers']

export const PRODUCTS = [
  {
    id: 'stickers-ng',
    slug: 'stickers-nature-gites',
    price: 9.5,
    priceExclTax: 7.92,
    stock: 120,
    category: 'stickers',
    size: 'Planche 10 × 15 cm',
    // Ajouter les photos fournies ici, ex. :
    images: [
       '/pictures/shop/stickers-ng/1.webp',
       '/pictures/shop/stickers-ng/2.webp',
       '/pictures/shop/stickers-ng/3.webp'
    ],
    motifs: ['leaf', 'cottage', 'orchard', 'sun', 'emblem', 'wild'],
    accent: '#1a472a',
    glow: '#a8e6b0',
    featured: true,
  },
]

export function getProductBySlug(slug) {
  return PRODUCTS.find((item) => item.slug === slug) || null
}

export function getProductById(id) {
  return PRODUCTS.find((item) => item.id === id) || null
}

export function formatPrice(value, language = 'fr') {
  const localeMap = {
    fr: 'fr-FR',
    en: 'en-GB',
    es: 'es-ES',
    it: 'it-IT',
    de: 'de-DE',
    zh: 'zh-CN',
    ar: 'ar-SA',
  }
  return new Intl.NumberFormat(localeMap[language] || 'fr-FR', {
    style: 'currency',
    currency: 'EUR',
  }).format(value)
}
